import { render, staticRenderFns } from "./VoucherAlert.vue?vue&type=template&id=6aa0bf84&scoped=true&"
import script from "./VoucherAlert.vue?vue&type=script&lang=ts&"
export * from "./VoucherAlert.vue?vue&type=script&lang=ts&"
import style0 from "./VoucherAlert.vue?vue&type=style&index=0&id=6aa0bf84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0bf84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
